var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6 0C2.504 0 0 2.504 0 5.6C0 9.8 5.6 16 5.6 16C5.6 16 11.2 9.8 11.2 5.6C11.2 2.504 8.696 0 5.6 0ZM5.6 7.6C5.06957 7.6 4.56086 7.38929 4.18579 7.01421C3.81071 6.63914 3.6 6.13043 3.6 5.6C3.6 5.06957 3.81071 4.56086 4.18579 4.18579C4.56086 3.81071 5.06957 3.6 5.6 3.6C6.13043 3.6 6.63914 3.81071 7.01421 4.18579C7.38929 4.56086 7.6 5.06957 7.6 5.6C7.6 6.13043 7.38929 6.63914 7.01421 7.01421C6.63914 7.38929 6.13043 7.6 5.6 7.6Z",
    fill: "#080A44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLocation);
export default __webpack_public_path__ + "static/media/ic_location.fee3db8f1821f9c0c7bd086774ee84f6.svg";
export { ForwardRef as ReactComponent };